'use client';
/*
 * @Author: linguang linguang@nextmar.com
 * @Date: 2025-04-08 10:29:02
 * @LastEditors: Gao Deng gaodeng@nextmar.com
 * @LastEditTime: 2025-04-23 15:39:54
 * @FilePath: /zeelool-nextjs/src/components/Address/ProvinceDialog.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { Province } from '@/api/types/public';
import { colors } from '@/theme/zeelool.theme';
import { Drawer } from '@mui/material';
import { WapNavBackOutlined } from '@zeelool/icon';
import { useTranslations } from 'next-intl';
import MobileNav from '../MobileNav';

export default function MobileProvinceDrawer({
  show,
  close,
  onSelect = () => {},
  data = [],
}: {
  show: boolean;
  close: () => void;
  onSelect?: (province?: Province) => void;
  data?: Province[];
}) {
  const t = useTranslations('address');

  return (
    <Drawer
      open={show}
      PaperProps={{
        sx: {
          width: '100%',
          height: '100vh',
          background: colors.auxiliaryGray,
        },
      }}
    >
      <div className="flex flex-col h-full font-br">
        <MobileNav
          className="bg-white"
          title={t('pleaseSelect')}
          titleClassName="text-center w-full"
          leftSlot={
            <div
              className="MobileNav flex items-center justify-center h-[40px] w-[40px] absolute left-0 top-5"
              onClick={close}
            >
              <WapNavBackOutlined className="text-20" />
            </div>
          }
        />
        <div className="flex-1 flex-shrink-0 relative" style={{ height: 'calc(100% - 50px)' }}>
          <div className="h-full overflow-y-auto flex flex-col pb-64 relative">
            {data.map((item) => (
              <div
                key={item.region_id}
                className="bg-white relative pt-20 pb-20 text-14 text-primary-black pl-16 pr-16 after:content-[' '] after:left-16 after:right-16 after:h-1 after:border-b-1 after:border-auxiliary-light-gray-blue after:flex after:absolute after:bottom-0 last:after:border-none"
                onClick={() => {
                  onSelect(item);
                  close();
                }}
              >
                {item.name}
              </div>
            ))}
          </div>
        </div>
      </div>
    </Drawer>
  );
}
